$shm_ba_user_settings $mol_view
	user_id \
	user_data null
	scope \all
	sub <= settings_rows /
		<= Mentions_enabled $mol_check_box
			title \Доступ к мониторингу упоминаний
			checked? <=> mentions_enabled? true
		<= Mention_stats_enabled $mol_check_box
			title \Доступ к статистике упоминаний
			checked? <=> mention_stats_enabled? false
		<= Wordstat_enabled $mol_check_box
			title \Доступ к Wordstat
			checked? <=> wordstat_enabled? false
		<= Wordstat_task_limit_label $mol_labeler
			title \Лимит задач Wordstat
			Content <= Wordstat_task_limit $mol_string
				keyboard \numeric
				hint \0 — без лимита
				value? <=> wordstat_task_limit_draft? \
				submit? <=> wordstat_task_limit_commit? null
				event *
					^
					blur? <=> wordstat_task_limit_commit? null
					keydown? <=> wordstat_task_limit_keydown? null
		<= Wordstat_hourly_request_limit_label $mol_labeler
			title \Лимит запросов Wordstat в час
			Content <= Wordstat_hourly_request_limit $mol_string
				keyboard \numeric
				hint \0 — без лимита
				value? <=> wordstat_hourly_request_limit_draft? \
				submit? <=> wordstat_hourly_request_limit_commit? null
				event *
					^
					blur? <=> wordstat_hourly_request_limit_commit? null
					keydown? <=> wordstat_hourly_request_limit_keydown? null
		<= Wordstat_regular_daily_task_limit_label $mol_labeler
			title \Лимит задач для ежедневного сбора
			Content <= Wordstat_regular_daily_task_limit $mol_string
				keyboard \numeric
				hint \0 — без лимита
				value? <=> wordstat_regular_daily_task_limit_draft? \
				submit? <=> wordstat_regular_daily_task_limit_commit? null
				event *
					^
					blur? <=> wordstat_regular_daily_task_limit_commit? null
					keydown? <=> wordstat_regular_daily_task_limit_keydown? null
		<= Wordstat_query_limit_label $mol_labeler
			title \Лимит строк запросов
			Content <= Wordstat_query_limit $mol_string
				keyboard \numeric
				value? <=> wordstat_query_limit_draft? \
				submit? <=> wordstat_query_limit_commit? null
				event *
					^
					blur? <=> wordstat_query_limit_commit? null
					keydown? <=> wordstat_query_limit_keydown? null
		<= Wordstat_subtask_limit_label $mol_labeler
			title \Лимит подзадач в задаче
			Content <= Wordstat_subtask_limit $mol_string
				keyboard \numeric
				value? <=> wordstat_subtask_limit_draft? \
				submit? <=> wordstat_subtask_limit_commit? null
				event *
					^
					blur? <=> wordstat_subtask_limit_commit? null
					keydown? <=> wordstat_subtask_limit_keydown? null
		<= Agent_settings $mol_view
			sub /
				<= Agent_enabled $mol_check_box
					title \Доступ к агенту
					checked? <=> agent_enabled? false
				<= Agent_url_label $mol_labeler
					title \URL агента
					Content <= Agent_url $mol_string
						value? <=> agent_url_draft? \
						submit? <=> agent_url_commit? null
						event *
							^
							blur? <=> agent_url_commit? null
							keydown? <=> agent_url_keydown? null
				<= Agent_token_label $mol_labeler
					title \Токен агента
					Content <= Agent_token $mol_password
						value? <=> agent_token_draft? \
						submit? <=> agent_token_commit? null
						event *
							^
							focusout? <=> agent_token_commit? null
							keydown? <=> agent_token_keydown? null
